export const SHOW_TEST_INTENT_SIDEBAR = 'SHOW_TEST_INTENT_SIDEBAR';

export const setTestIntentSidebarVisible = visible => ({
    type: SHOW_TEST_INTENT_SIDEBAR,
    payload: visible
});